import { useEffect, useState } from "react";

/**
 * Fica verdadeiro na primeira vez em que a seção deixa de estar recolhida
 * e não volta atrás. A busca usa isso como `enabled`: fechar não dispara
 * outra rede; o cache segura a reabertura.
 */
export function useHasSectionOpened(isCollapsed: boolean): boolean {
  const [hasOpened, setHasOpened] = useState(!isCollapsed);

  useEffect(() => {
    if (!isCollapsed) setHasOpened(true);
  }, [isCollapsed]);

  return hasOpened;
}
